import { ELEMENT_RETRY_COUNT, findElement } from '../domLocator'
import humanLabel, { DROPDOWN_AGENT_IDS } from '../humanLabel'
import { ClientTool, failure, success } from '../Tool'

interface Input extends Record<string, unknown> {
  agentId: string
}

/**
 * Clicks an element identified by data-agent-id. If the element is itself a
 * button or anchor, clicks it directly. Otherwise falls back to the first
 * [role="combobox"], button, or anchor inside (allowing dom_click to open
 * dropdown triggers), then to the container element itself.
 */
const domClick: ClientTool = {
  name: 'dom_click',
  category: 'mutation',
  execute: async (rawInput) => {
    const { agentId } = rawInput as Input
    const el = await findElement(agentId)
    if (!el) {
      return failure(`Element ${agentId} not found after ${ELEMENT_RETRY_COUNT} retries`)
    }
    const target =
      el instanceof HTMLButtonElement || el instanceof HTMLAnchorElement
        ? el
        : (el.querySelector('[role="combobox"], button, a') as HTMLElement | null) ??
          (el as HTMLElement)
    target.click()
    return success()
  },
  getStepLabel: (rawInput) => {
    const { agentId } = rawInput as Input
    return DROPDOWN_AGENT_IDS.has(agentId)
      ? `Opening ${humanLabel(agentId)}…`
      : `Submitting ${humanLabel(agentId)}…`
  }
}

export default domClick
